<template>
  <div v-if="inventory">
    <p class="default_txt text-center">Are you sure?</p>
    <div class="d-flex justify-center mt-2 pb-5">
      <v-btn
        class="text-capitalize rounded-lg mr-3 pa-6"
        depressed
        dark
        outlined
        color="#006341"
        @click="$emit('close')"
        >Cancel</v-btn
      >
      <v-btn
        class="bg_default text-capitalize rounded-lg pa-6"
        depressed
        dark
        @click="deleteData"
        >Delete</v-btn
      >
    </div>
    <div style="height: 30px"></div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "deleteUp",
  props: ["inventory"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    deleteData() {
      this.loading = true;
      let body = {
        id: this.inventory.id,
      };
      let data = {
        path: this.inventory.path,
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
